export enum EmailErrorCode {
  EMAIL_BLOCKED = 'EMAIL_BLOCKED',
  EMAIL_ALREADY_TAKEN = 'EMAIL_ALREADY_TAKEN',
  UNVERIFIED_EMAIL = 'UNVERIFIED_EMAIL',
}
